import { Injectable } from "@angular/core";
import { IUseCase } from "@karma-games/angular-devkit/src/lib/interfaces";
import { Observable } from "rxjs";
import { ERoundState, IRound } from "../interfaces";
import { RoundRepository } from "../round.repository";
import { map } from "rxjs/operators";

@Injectable()
export class GetRoundStateUseCase implements IUseCase<void, Observable<ERoundState>> {
    constructor(private roundRepository: RoundRepository) {
    }

    execute(): Observable<ERoundState> {
        return this.roundRepository.get().pipe(map((round: IRound) => round.state));
    }
}
